// Several editors on one form share a single `onUploadingChange` (usually a state setter). Each one reports into a
// per-callback set of uploading editors, so the callback receives "is any editor uploading" instead of whichever
// editor reported last — one editor finishing must not re-enable submit while another is still uploading.
const uploadingEditors = new WeakMap<(isUploading: boolean) => void, Set<string>>()

export function reportEditorUploading(
	callback: (isUploading: boolean) => void,
	editorId: string,
	isUploading: boolean
): void {
	let editors = uploadingEditors.get(callback)
	if (!editors) {
		editors = new Set()
		uploadingEditors.set(callback, editors)
	}
	if (isUploading) editors.add(editorId)
	else editors.delete(editorId)
	callback(editors.size > 0)
}

let editorTokenCount = 0

/** A token unique to one editor mount. `useId()` can repeat for a replacement editor mounted at the same
 * position, which would let the old editor's late "done" clear the replacement's pending upload. */
export const newEditorToken = (): string => `editor-${++editorTokenCount}`
